import React, { useRef } from 'react';

import _ from 'lodash';
import { Formik, getIn } from 'formik';

const Form = props => {
  const {
    children,
    autoComplete = 'off',
    initialValues,
    session,
    className,
    ...rest
  } = props;

  const key = useRef(session);

  if (typeof children !== 'function') {
    throw new Error('Form children must be a function that return a React component');
  }

  return (
    <Formik {...rest} initialValues={initialValues} enableReinitialize>
      {props => {
        if (key.current !== session) {
          key.current = session;
          props.resetForm({ values: initialValues });
          return null;
        }

        const { values, errors, touched, handleChange, handleBlur, handleSubmit } = props;

        const fieldProps = (name, label, defVal) => ({
          name,
          label: label || _.capitalize(name),
          value: _.get(values, name, defVal),
          onChange: handleChange,
          onBlur: handleBlur,
          error: !!(getIn(touched, name) && getIn(errors, name)),
          helperText: (getIn(touched, name) && getIn(errors, name)) || ' ',
          inputProps: { maxLength: 100 },
          fullWidth: true,
        });

        const checkboxProps = name => ({
          name,
          checked: _.get(values, name),
          onChange: handleChange,
          onBlur: handleBlur,
        });

        return (
          <form
            className={className}
            onSubmit={handleSubmit}
            noValidate
            autoComplete={autoComplete}
            onKeyDown={e => (e.key === 'Enter' ? e.preventDefault() : null)}
          >
            {children({ ...props, fieldProps, checkboxProps })}
          </form>
        );
      }}
    </Formik>
  );
};

export default Form;
